import type { SinglePagePdf, VirtualFile } from "@pdfking/pdfengine"
import { ArrayToIterable } from "@pdfking/tfunc"
import { toRaw } from "vue"

import { SplitPdf } from "./pdfengine/Functions"

export default (s: undefined | VirtualFile): AsyncGenerator<SinglePagePdf> =>
  s ? SplitPdf(toRaw(s)) : ArrayToIterable()
